import { buildAsyncCategoryOptionsState } from "components/search-bar/AsyncCategoryOptionsStateBuilder";
import { urlProductTypeOpenSearchCategory } from "modules/domain-data/FinVehicleDomainData";
import { urlLocationOpenSearchCategory } from "modules/domain-data/FinVehicleDomainData";
import { RequestMethod } from "api/consts";
import { FilterType } from "api/consts";

export const productTypeLoaderState = buildAsyncCategoryOptionsState({
  topic: "PRODUCT_TYPE",
  getUrl: urlProductTypeOpenSearchCategory,
  queryParam: "q",
  getResponseData: (data) => data?.data ?? [],
  transformResult: (item) => {
    return { label: item.value, value: item.value };
  },
  debounceWaitTimeInMs: 500,
  method: RequestMethod.POST,
});

export const locationLoaderState = buildAsyncCategoryOptionsState({
  topic: "LOCATION",
  getUrl: urlLocationOpenSearchCategory,
  queryParam: "q",
  getResponseData: (data) => data?.data ?? [],
  transformResult: (item) => {
    return {
      label: `${item.value} (${item.key})`,
      value: item.key,
    };
  },
  debounceWaitTimeInMs: 500,
  method: RequestMethod.POST,
});
